import React from 'react';
import ReportesPowerCV from './controladorVista/reportesPowerCV';
import { IEstadoAPropsReportesPowerCV } from './interfaces';

const ReportesPowerBI: React.FunctionComponent<IEstadoAPropsReportesPowerCV> = ({nombreReporte, filtro}) => <ReportesPowerCV nombreReporte={nombreReporte} filtro={filtro}/>;

export default ReportesPowerBI;
